import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../App';

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#1a1a2e',
    padding: '20px',
  },
  header: {
    color: '#e94560',
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '4px',
    marginTop: '20px',
    textAlign: 'center',
  },
  subtitle: {
    color: '#a0a0b0',
    fontSize: '14px',
    marginBottom: '8px',
    textAlign: 'center',
  },
  dealerName: {
    color: '#ffffff',
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '24px',
  },
  card: {
    backgroundColor: '#16213e',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '12px',
  },
  filterCard: {
    backgroundColor: '#16213e',
    borderRadius: '16px',
    padding: '16px',
    marginBottom: '12px',
  },
  filterSection: {
    marginBottom: '12px',
  },
  filterLabel: {
    color: '#a0a0b0',
    fontSize: '11px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '8px',
  },
  filterRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  filterButton: {
    padding: '8px 16px',
    backgroundColor: '#0f3460',
    border: '2px solid #0f3460',
    borderRadius: '20px',
    color: '#a0a0b0',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  filterButtonActive: {
    padding: '8px 16px',
    backgroundColor: '#0f3460',
    border: '2px solid #e94560',
    borderRadius: '20px',
    color: '#e94560',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  filterButtonAll: {
    padding: '8px 16px',
    backgroundColor: '#e94560',
    border: '2px solid #e94560',
    borderRadius: '20px',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  filterButtonAllInactive: {
    padding: '8px 16px',
    backgroundColor: '#0f3460',
    border: '2px solid #0f3460',
    borderRadius: '20px',
    color: '#a0a0b0',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  codeRow: {
    marginBottom: '16px',
  },
  codeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '6px',
  },
  codeName: {
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  codeValue: {
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  codeDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  benchmark: {
    color: '#a0a0b0',
    fontSize: '12px',
  },
  vsGood: {
    color: '#4caf50',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  vsBad: {
    color: '#e94560',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  barContainer: {
    height: '8px',
    backgroundColor: '#0f3460',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  barGood: {
    height: '8px',
    backgroundColor: '#4caf50',
    borderRadius: '4px',
    transition: 'width 0.5s ease',
  },
  barBad: {
    height: '8px',
    backgroundColor: '#e94560',
    borderRadius: '4px',
    transition: 'width 0.5s ease',
  },
  summaryCard: {
    backgroundColor: '#16213e',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-around',
    textAlign: 'center',
  },
  summaryNumber: {
    color: '#e94560',
    fontSize: '28px',
    fontWeight: 'bold',
  },
  summaryLabel: {
    color: '#a0a0b0',
    fontSize: '12px',
    marginTop: '4px',
  },
  newButton: {
    width: '100%',
    padding: '20px',
    backgroundColor: '#e94560',
    border: 'none',
    borderRadius: '12px',
    color: '#ffffff',
    fontSize: '20px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '8px',
    marginBottom: '12px',
  },
  homeButton: {
    width: '100%',
    padding: '16px',
    backgroundColor: 'transparent',
    border: '2px solid #0f3460',
    borderRadius: '12px',
    color: '#a0a0b0',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginBottom: '24px',
  },
  loading: {
    color: '#a0a0b0',
    textAlign: 'center',
    marginTop: '60px',
    fontSize: '16px',
  },
  sectionTitle: {
    color: '#a0a0b0',
    fontSize: '12px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '12px',
    marginTop: '8px',
  },
  roundCount: {
    color: '#a0a0b0',
    fontSize: '12px',
    textAlign: 'right',
    marginBottom: '4px',
  },
};

const CODE_DESCRIPTIONS = {
  TCO: 'Time Cards Out',
  TTD: 'Time to Draw',
  TPU: 'Time Pick Up',
  SPT: 'Spin Time',
  SWT: 'Sweep Time',
  OPT: 'Outside Pay Time',
  IPT: 'Inside Pay Time',
  PTT: 'Pay/Take Time',
  TBR: 'Time Between Rounds',
  DPT: 'Deal & Pay Time',
  TRT: 'Total Round Time',
  TST: 'Total Shuffle Time',
  AST: 'After Shuffle Time',
  TCT: 'Total Change Time',
  ACT: 'After Change Time',
  OTT: 'Other Pause Time',
  AOT: 'After Other Time',
};

const CODE_ORDER = ['TCO', 'TTD', 'TPU', 'SPT', 'SWT', 'OPT', 'IPT', 'PTT', 'DPT', 'TBR', 'TRT', 'TST', 'AST', 'TCT', 'ACT', 'OTT', 'AOT'];

function getBarWidth(avg, benchmark) {
  if (!benchmark || benchmark === 0) return 50;
  const ratio = avg / benchmark;
  return Math.min(Math.round(ratio * 100), 100);
}

function SessionEnd() {
  const [report, setReport] = useState(null);
  const [dem, setDem] = useState(null);
  const [survey, setSurvey] = useState({ questions: [], answers: {} });
  const [filters, setFilters] = useState(null);
  const [activeV1, setActiveV1] = useState([]);
  const [activeV2, setActiveV2] = useState([]);
  const [activeV4, setActiveV4] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const sessionId = localStorage.getItem('session_id');
  const dealer = JSON.parse(localStorage.getItem('dealer') || '{}');
  const roundNumber = parseInt(localStorage.getItem('round_number') || '1');

  useEffect(() => {
    if (!sessionId) return;
    fetch(`${API}/sessions/${sessionId}/filters`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => setFilters(data))
      .catch(() => {});
    fetch(`${API}/sessions/${sessionId}/survey`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(d => setSurvey({ questions: d.questions || [], answers: d.answers || {} }))
      .catch(() => {});
    fetch(`${API}/sessions/${sessionId}/dem`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => setDem(data))
      .catch(() => {});
  }, [sessionId, token]);

  const fetchReport = useCallback(() => {
    if (!sessionId) return;
    setLoading(true);
    const params = new URLSearchParams();
    activeV1.forEach(v => params.append('v1', v));
    activeV2.forEach(v => params.append('v2', v));
    activeV4.forEach(v => params.append('v4', v));
    const query = params.toString() ? `?${params.toString()}` : '';
    fetch(`${API}/sessions/${sessionId}/report${query}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => {
        setReport(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [sessionId, token, activeV1, activeV2, activeV4]);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  function toggleFilter(type, value) {
    if (type === 'v1') {
      setActiveV1(prev =>
        prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
      );
    } else if (type === 'v2') {
      setActiveV2(prev =>
        prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
      );
    } else if (type === 'v4') {
      setActiveV4(prev =>
        prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
      );
    }
  }

  function clearFilters() {
    setActiveV1([]);
    setActiveV2([]);
    setActiveV4([]);
  }

  const isAllActive = activeV1.length === 0 && activeV2.length === 0 && activeV4.length === 0;

  // Start a fresh session keeping the same dealer + game (+ table/target).
  async function startSameSession() {
    const gameType = JSON.parse(localStorage.getItem('game_type') || '{}');
    const target = localStorage.getItem('target_rounds') || '0';
    const savedTable = localStorage.getItem('table_number') || '';
    if (!dealer.id || !gameType.id) {
      newSession();
      return;
    }
    try {
      const res = await fetch(`${API}/sessions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          dealer_id: dealer.id,
          game_type_id: gameType.id,
          table_number: savedTable || null,
          target_rounds: target && target !== '0' ? parseInt(target) : null,
        }),
      });
      const data = await res.json();
      if (!data.session_id) {
        alert('Could not start new session');
        return;
      }
      localStorage.setItem('session_id', data.session_id);
      localStorage.setItem('round_number', '1');
      navigate('/survey');
    } catch (e) {
      alert('Could not start new session');
    }
  }

  function newSession() {
    localStorage.removeItem('session_id');
    localStorage.removeItem('game_type');
    localStorage.removeItem('target_rounds');
    localStorage.removeItem('round_number');
    localStorage.removeItem('table_number');
    navigate('/select-dealer');
  }

  function goHome() {
    localStorage.clear();
    navigate('/login');
  }

  const results = report?.results || [];
  const orderedResults = CODE_ORDER
    .map(code => results.find(r => r.code === code))
    .filter(Boolean);

  const dealingCodes = orderedResults.filter(r =>
    ['TCO', 'TTD', 'TPU', 'SPT', 'SWT', 'OPT', 'IPT', 'PTT', 'DPT', 'TBR', 'TRT'].includes(r.code)
  );
  const shuffleCodes = orderedResults.filter(r =>
    ['TST', 'AST'].includes(r.code)
  );
  const changeCodes = orderedResults.filter(r =>
    ['TCT', 'ACT'].includes(r.code)
  );
  const otherCodes = orderedResults.filter(r =>
    ['OTT', 'AOT'].includes(r.code)
  );

  const hasBench = r => r.vs_benchmark !== null && r.vs_benchmark !== undefined;
  const aboveBenchmark = orderedResults.filter(r => hasBench(r) && r.vs_benchmark > 0).length;
  const belowBenchmark = orderedResults.filter(r => hasBench(r) && r.vs_benchmark <= 0).length;

  function renderCodeRow(result) {
    const benchSet = hasBench(result);
    const isGood = benchSet && result.vs_benchmark <= 0;
    const barWidth = getBarWidth(result.avg_seconds, result.benchmark);
    return (
      <div key={result.code} style={styles.codeRow}>
        <div style={styles.codeHeader}>
          <div>
            <span style={styles.codeName}>{result.code}</span>
            <span style={{ color: '#a0a0b0', fontSize: '12px', marginLeft: '8px' }}>
              {CODE_DESCRIPTIONS[result.code]}
            </span>
          </div>
          <div style={styles.codeValue}>{result.avg_seconds}s</div>
        </div>
        <div style={styles.codeDetails}>
          <span style={styles.benchmark}>
            Benchmark: {benchSet ? `${result.benchmark}s` : 'not set'} · {result.count} rounds
          </span>
          {benchSet && (
            <span style={isGood ? styles.vsGood : styles.vsBad}>
              {isGood ? '▼' : '▲'} {Math.abs(result.vs_benchmark)}s {isGood ? 'under' : 'over'}
            </span>
          )}
        </div>
        <div style={styles.barContainer}>
          <div style={{
            ...(isGood ? styles.barGood : styles.barBad),
            width: `${barWidth}%`,
          }} />
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>Session Report</div>
      <div style={styles.subtitle}>{new Date().toLocaleDateString()}</div>
      <div style={styles.dealerName}>
        {dealer.first_name} {dealer.last_name}
      </div>

      {survey.questions.filter(q => q.active || survey.answers[q.id]).length > 0 && (
        <div style={{
          backgroundColor: '#16213e', borderRadius: '16px', padding: '16px', marginBottom: '12px',
        }}>
          <div style={{
            color: '#a0a0b0', fontSize: '12px', fontWeight: 'bold', letterSpacing: '1px',
            textTransform: 'uppercase', marginBottom: '10px',
          }}>
            Behavior scores
          </div>
          {survey.questions.filter(q => q.active || survey.answers[q.id]).map(q => (
            <div key={q.id} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px',
              padding: '8px 0', borderBottom: '1px solid #0f3460',
            }}>
              <div style={{ color: '#ffffff', fontSize: '15px', lineHeight: 1.35 }}>
                {q.question_text}
                <div style={{ color: '#a0a0b0', fontSize: '12px' }}>Survey {q.slot} · 1 to {q.scale_max}</div>
              </div>
              <div style={{
                color: survey.answers[q.id] ? '#ffcc00' : '#a0a0b0',
                fontSize: survey.answers[q.id] ? '26px' : '14px', fontWeight: 'bold', whiteSpace: 'nowrap',
              }}>
                {survey.answers[q.id] || 'not scored'}
              </div>
            </div>
          ))}
          <div style={{ color: '#a0a0b0', fontSize: '12px', marginTop: '10px' }}>
            Saved with the test. These scores are final.
          </div>
        </div>
      )}

      {dem && dem.data_purpose === 'benchmark' && dem.session_deal_rounds < dem.min_benchmark_rounds && (
        <div style={{
          backgroundColor: 'rgba(255, 204, 0, 0.12)',
          border: '1px solid #ffcc00',
          borderRadius: '12px',
          color: '#ffcc00',
          fontSize: '14px',
          padding: '12px 14px',
          marginBottom: '12px',
          lineHeight: 1.4,
        }}>
          This test is too short to count toward the benchmark (needs {dem.min_benchmark_rounds} rounds).
          It still counts for the dealer's results.
        </div>
      )}
      
    {report?.stats && (
        <div style={{
          backgroundColor: '#16213e',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '12px',
          textAlign: 'center',
        }}>
          <div style={{ color: '#a0a0b0', fontSize: '12px', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '16px' }}>
            Primary Stats
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '18px' }}>
            <div>
              <div style={{ color: '#4caf50', fontSize: '40px', fontWeight: 'bold' }}>
                {dem && dem.session_dem != null ? dem.session_dem.toFixed(2) : '—'}
              </div>
              <div style={{ color: '#a0a0b0', fontSize: '12px', marginTop: '4px' }}>DEM</div>
            </div>
            <div>
              <div style={{ color: '#4caf50', fontSize: '40px', fontWeight: 'bold' }}>
                {dem && dem.dealer_percentile != null ? `${dem.dealer_percentile}%` : '—'}
              </div>
              <div style={{ color: '#a0a0b0', fontSize: '12px', marginTop: '4px' }}>Percentile</div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '8px' }}>
            <div>
              <div style={{ color: '#e94560', fontSize: '26px', fontWeight: 'bold' }}>
                {report.stats.rph || '—'} <span style={{ fontSize: '16px', color: '#a0a0b0' }}>@</span> {report.stats.spr || '—'}
              </div>
              <div style={{ color: '#a0a0b0', fontSize: '12px', marginTop: '4px' }}>RPH @ SPR</div>
            </div>
            <div>
              <div style={{ color: '#e94560', fontSize: '26px', fontWeight: 'bold' }}>
                {report.stats.hph || '—'}
              </div>
              <div style={{ color: '#a0a0b0', fontSize: '12px', marginTop: '4px' }}>HPH</div>
            </div>
          </div>
          <div style={{ color: '#a0a0b0', fontSize: '12px', marginTop: '10px', lineHeight: 1.5 }}>
            {dem && dem.session_dem == null && `Session DEM needs ≥${dem.session_min_rounds} rounds · `}
            {dem && dem.dealer_dem != null
              ? `Overall ${dem.dealer_dem.toFixed(2)} DEM · ${dem.dealer_rounds} rounds`
              : `Not yet ranked · needs ≥${dem?.pool_min_rounds || 20} rounds`}
          </div>
          {report.benchmark_label && (
            <div style={{
              color: report.benchmark_provisional ? '#ffcc00' : '#a0a0b0',
              fontSize: '12px', marginTop: '6px',
            }}>
              Measured against: {report.benchmark_label}
            </div>
          )}
        </div>
      )}

      <div style={styles.summaryCard}>
        <div>
          <div style={styles.summaryNumber}>{roundNumber - 1}</div>
          <div style={styles.summaryLabel}>Rounds</div>
        </div>
        <div>
          <div style={{ ...styles.summaryNumber, color: '#4caf50' }}>
            {belowBenchmark}
          </div>
          <div style={styles.summaryLabel}>Under benchmark</div>
        </div>
        <div>
          <div style={{ ...styles.summaryNumber, color: '#e94560' }}>
            {aboveBenchmark}
          </div>
          <div style={styles.summaryLabel}>Over benchmark</div>
        </div>
      </div>

      {filters && (
        <div style={styles.filterCard}>
          <div style={{ ...styles.sectionTitle, marginBottom: '12px' }}>
            Filter results
          </div>

          {filters.v1 && filters.v1.length > 1 && (
            <div style={styles.filterSection}>
              <div style={styles.filterLabel}>Spots</div>
              <div style={styles.filterRow}>
                {filters.v1.map(v => (
                  <button
                    key={v}
                    style={activeV1.includes(v) ? styles.filterButtonActive : styles.filterButton}
                    onClick={() => toggleFilter('v1', v)}
                  >
                    {v}
                  </button>
                ))}
              </div>
            </div>
          )}

          {filters.v2 && filters.v2.length > 1 && (
            <div style={styles.filterSection}>
              <div style={styles.filterLabel}>Complexity</div>
              <div style={styles.filterRow}>
                {filters.v2.map(v => (
                  <button
                    key={v}
                    style={activeV2.includes(v) ? styles.filterButtonActive : styles.filterButton}
                    onClick={() => toggleFilter('v2', v)}
                  >
                    {v}
                  </button>
                ))}
              </div>
            </div>
          )}

          {filters.v4 && filters.v4.length > 1 && (
            <div style={styles.filterSection}>
              <div style={styles.filterLabel}>Outcome</div>
              <div style={styles.filterRow}>
                {filters.v4.map(v => (
                  <button
                    key={v}
                    style={activeV4.includes(v) ? styles.filterButtonActive : styles.filterButton}
                    onClick={() => toggleFilter('v4', v)}
                  >
                    {v}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div style={{ marginTop: '12px' }}>
            <button
              style={isAllActive ? styles.filterButtonAll : styles.filterButtonAllInactive}
              onClick={clearFilters}
            >
              All
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <div style={styles.loading}>Updating...</div>
      ) : (
        <>
          {dealingCodes.length > 0 && (
            <div style={styles.card}>
              <div style={styles.sectionTitle}>Dealing Round</div>
              {dealingCodes.map(renderCodeRow)}
            </div>
          )}

          {shuffleCodes.length > 0 && (
            <div style={styles.card}>
              <div style={styles.sectionTitle}>Shuffle</div>
              {shuffleCodes.map(renderCodeRow)}
            </div>
          )}

          {changeCodes.length > 0 && (
            <div style={styles.card}>
              <div style={styles.sectionTitle}>Change</div>
              {changeCodes.map(renderCodeRow)}
            </div>
          )}

          {otherCodes.length > 0 && (
            <div style={styles.card}>
              <div style={styles.sectionTitle}>Other Pauses</div>
              {otherCodes.map(renderCodeRow)}
            </div>
          )}
        </>
      )}

      <button style={styles.newButton} onClick={startSameSession}>
        New Test — Same Dealer &amp; Game
      </button>
      <button style={styles.homeButton} onClick={newSession}>
        New Dealer
      </button>
      <button style={styles.homeButton} onClick={goHome}>
        Sign Out
      </button>
    </div>
  );
}

export default SessionEnd;